export interface ToolItem {
  to: string;
  icon: string;
  title: string;
  description: string;
}

export interface ToolCategory {
  id: string;
  label: string;
  description: string;
  tools: ToolItem[];
}

export const toolCategories: ToolCategory[] = [
  {
    id: "cobranca",
    label: "Cobrança e recebimento",
    description: "Receba mais rápido e sem perder dinheiro nas taxas.",
    tools: [
      {
        to: "/ferramentas/gerador-qr-code-pix",
        icon: "QrCode",
        title: "Gerador de QR Code PIX",
        description: "Crie o QR Code e o código copia e cola da sua chave PIX, com ou sem valor definido.",
      },
      {
        to: "/ferramentas/calculadora-taxa-maquininha",
        icon: "CreditCard",
        title: "Calculadora de taxas de pagamento",
        description: "Quanto sobra depois da taxa do cartão e quanto cobrar para receber o valor cheio.",
      },
      {
        to: "/ferramentas/calculadora-juros-atraso",
        icon: "AlarmClock",
        title: "Juros e multa por atraso",
        description: "Calcule multa, juros pro rata die e o valor atualizado de uma cobrança atrasada.",
      },
      {
        to: "/ferramentas/calculadora-de-parcelamento",
        icon: "Layers",
        title: "Simulador de parcelamento",
        description: "Valor da parcela, total pago e custo dos juros comparado ao pagamento à vista.",
      },
      {
        to: "/ferramentas/calculadora-de-desconto",
        icon: "Tag",
        title: "Calculadora de desconto",
        description: "Preço final com desconto ou acréscimo e quanto o cliente economiza à vista.",
      },
    ],
  },
  {
    id: "precificacao",
    label: "Precificação e finanças",
    description: "Saiba quanto cobrar e quanto realmente sobra no fim do mês.",
    tools: [
      {
        to: "/ferramentas/calculadora-preco-hora-freelancer",
        icon: "Calculator",
        title: "Calculadora de preço por hora",
        description: "Quanto cobrar por hora considerando custos, impostos, férias e horas faturáveis.",
      },
      {
        to: "/ferramentas/calculadora-custo-de-projeto",
        icon: "ClipboardList",
        title: "Calculadora de custo de projeto",
        description: "Some etapas, horas, custos extras, margem de risco e chegue no preço final.",
      },
      {
        to: "/ferramentas/calculadora-margem-markup",
        icon: "TrendingUp",
        title: "Margem de lucro e markup",
        description: "Entenda a diferença entre margem e markup e ache o preço da margem desejada.",
      },
      {
        to: "/ferramentas/calculadora-reajuste-contrato",
        icon: "ArrowUpRight",
        title: "Reajuste de contrato",
        description: "Reajuste valores por IPCA, IGP-M ou INPC e veja a diferença mensal e anual.",
      },
      {
        to: "/ferramentas/calculadora-reserva-de-emergencia",
        icon: "PiggyBank",
        title: "Reserva de emergência",
        description: "Quanto guardar para atravessar meses sem projeto e em quanto tempo chegar lá.",
      },
      {
        to: "/ferramentas/calculadora-de-horas",
        icon: "Timer",
        title: "Calculadora de horas trabalhadas",
        description: "Some lançamentos de início, fim e intervalo e veja quanto faturar no período.",
      },
      {
        to: "/ferramentas/calculadora-de-porcentagem",
        icon: "Percent",
        title: "Calculadora de porcentagem",
        description: "Porcentagem de um valor, variação entre dois números e aumentos ou reduções.",
      },
    ],
  },
  {
    id: "impostos",
    label: "Impostos e MEI",
    description: "Estimativas rápidas para não ser pego de surpresa pelo Leão.",
    tools: [
      {
        to: "/ferramentas/calculadora-limite-mei",
        icon: "PiggyBank",
        title: "Limite de faturamento MEI",
        description: "Veja quanto ainda pode faturar no ano sem estourar o teto e ser desenquadrado.",
      },
      {
        to: "/ferramentas/calculadora-simples-nacional",
        icon: "Landmark",
        title: "Calculadora do Simples Nacional",
        description: "Alíquota efetiva e valor estimado do DAS pelos anexos III e V, com fator R.",
      },
      {
        to: "/ferramentas/calculadora-inss-autonomo",
        icon: "ShieldCheck",
        title: "Calculadora de INSS do autônomo",
        description: "Contribuição de 5%, 11% ou 20% e o impacto no seu benefício futuro.",
      },
      {
        to: "/ferramentas/calculadora-carne-leao",
        icon: "Receipt",
        title: "Calculadora do carnê-leão",
        description: "Imposto de renda mensal do autônomo com tabela progressiva e deduções.",
      },
      {
        to: "/ferramentas/validador-cpf-cnpj",
        icon: "ShieldCheck",
        title: "Validador de CPF e CNPJ",
        description: "Confira os dígitos verificadores antes de cadastrar o cliente.",
      },
    ],
  },
  {
    id: "documentos",
    label: "Documentos e propostas",
    description: "Gere PDFs profissionais em minutos, sem template no Word.",
    tools: [
      {
        to: "/ferramentas/gerador-de-orcamento",
        icon: "FileText",
        title: "Gerador de orçamento em PDF",
        description: "Monte uma proposta item a item e baixe em PDF pronta para enviar.",
      },
      {
        to: "/ferramentas/gerador-de-proposta-comercial",
        icon: "Presentation",
        title: "Gerador de proposta comercial",
        description: "Escopo, entregáveis, prazo e investimento em um documento que fecha negócio.",
      },
      {
        to: "/ferramentas/gerador-de-contrato",
        icon: "FileSignature",
        title: "Gerador de contrato",
        description: "Contrato de prestação de serviços: escopo, prazo, pagamento e revisões.",
      },
      {
        to: "/ferramentas/gerador-de-nda",
        icon: "Lock",
        title: "Gerador de NDA",
        description: "Termo de confidencialidade entre prestador e cliente, pronto para assinar.",
      },
      {
        to: "/ferramentas/gerador-de-recibo",
        icon: "Receipt",
        title: "Gerador de recibo",
        description: "Recibo em PDF com valor por extenso, descrição do serviço e assinatura.",
      },
      {
        to: "/ferramentas/gerador-de-declaracao-de-servico",
        icon: "FileCheck",
        title: "Declaração de prestação de serviço",
        description: "Comprove atividade e renda com uma declaração formatada em PDF.",
      },
      {
        to: "/ferramentas/gerador-de-briefing",
        icon: "ListChecks",
        title: "Gerador de briefing",
        description: "Colete objetivo, público, referências e requisitos antes de começar o projeto.",
      },
      {
        to: "/ferramentas/gerador-de-cronograma",
        icon: "CalendarRange",
        title: "Gerador de cronograma",
        description: "Etapas com datas, responsáveis e duração em dias úteis, exportado em PDF.",
      },
    ],
  },
  {
    id: "produtividade",
    label: "Prazos e produtividade",
    description: "Combine prazos realistas e organize o dia a dia.",
    tools: [
      {
        to: "/ferramentas/calculadora-dias-uteis",
        icon: "CalendarClock",
        title: "Calculadora de dias úteis",
        description: "Some prazos ou conte dias úteis entre datas, já descontando feriados.",
      },
      {
        to: "/ferramentas/gerador-link-whatsapp",
        icon: "MessageCircle",
        title: "Gerador de link do WhatsApp",
        description: "Link wa.me com mensagem automática e QR Code, sem salvar o contato.",
      },
      {
        to: "/ferramentas/gerador-de-assinatura-de-email",
        icon: "Mail",
        title: "Gerador de assinatura de e-mail",
        description: "Assinatura profissional com contatos e redes, pronta para copiar e colar.",
      },
      {
        to: "/ferramentas/gerador-de-senha",
        icon: "KeyRound",
        title: "Gerador de senha forte",
        description: "Senhas aleatórias e seguras geradas no seu navegador, com medidor de força.",
      },
      {
        to: "/ferramentas/gerador-de-uuid",
        icon: "Fingerprint",
        title: "Gerador de UUID",
        description: "Gere identificadores únicos v4 em lote e copie tudo de uma vez.",
      },
    ],
  },
  {
    id: "conteudo",
    label: "Conteúdo, marketing e web",
    description: "Utilitários para quem produz conteúdo, sites e campanhas.",
    tools: [
      {
        to: "/ferramentas/gerador-de-qr-code",
        icon: "QrCode",
        title: "Gerador de QR Code",
        description: "QR Code para link, texto, e-mail, telefone ou Wi-Fi, com download em PNG.",
      },
      {
        to: "/ferramentas/gerador-de-link-utm",
        icon: "Link2",
        title: "Gerador de link com UTM",
        description: "Rastreie campanhas com parâmetros UTM padronizados e presets prontos.",
      },
      {
        to: "/ferramentas/gerador-de-meta-tags",
        icon: "Globe",
        title: "Gerador de meta tags SEO",
        description: "Title, description, Open Graph e Twitter com preview do resultado no Google.",
      },
      {
        to: "/ferramentas/gerador-de-slug",
        icon: "Hash",
        title: "Gerador de slug de URL",
        description: "Transforme títulos em URLs limpas, sem acentos, em lote.",
      },
      {
        to: "/ferramentas/contador-de-palavras",
        icon: "Type",
        title: "Contador de palavras e caracteres",
        description: "Palavras, caracteres, parágrafos, tempo de leitura e limites das redes.",
      },
      {
        to: "/ferramentas/gerador-de-lorem-ipsum",
        icon: "AlignLeft",
        title: "Gerador de Lorem Ipsum",
        description: "Texto fictício em latim ou português para preencher layouts.",
      },
      {
        to: "/ferramentas/gerador-de-paleta-de-cores",
        icon: "Palette",
        title: "Gerador de paleta de cores",
        description: "Harmonias complementares, análogas e triádicas a partir de uma cor base.",
      },
      {
        to: "/ferramentas/conversor-de-cores",
        icon: "Pipette",
        title: "Conversor de cores HEX, RGB e HSL",
        description: "Converta formatos e confira o contraste segundo as diretrizes WCAG.",
      },
      {
        to: "/ferramentas/formatador-de-json",
        icon: "Braces",
        title: "Formatador e validador de JSON",
        description: "Identação, minificação e mensagens de erro claras para JSON quebrado.",
      },
      {
        to: "/ferramentas/conversor-base64",
        icon: "Binary",
        title: "Conversor Base64",
        description: "Codifique e decodifique texto em Base64, com suporte a acentos e URL-safe.",
      },
    ],
  },
];

export const allTools: ToolItem[] = toolCategories.flatMap((category) => category.tools);
